import { ENTITY } from '../constant';
import { constants } from '../constant/constant';
import { dateFormat } from '../helper/StringUtils';
import { CLIENT } from '../constant/actionTypes';
import { httpserviceWithMultipart, httpservice } from '../services';

const doCreateClientUser = (data) => {
  console.log(data);

  let apiEndPoint = constants.ADMIN_URL;
  const loginUser = sessionStorage.getItem('cred') ? JSON.parse(sessionStorage.getItem('cred')).userData : false;

  if (loginUser) {
    if (loginUser.role.roleName === 'client') {
      apiEndPoint = constants.CLIENT_URL;
    }
  }

  return httpserviceWithMultipart('post', data, apiEndPoint + constants.API.CLINET_USER)
    .then((response) => response.data)
    .catch((error) => error.response.data);
};

const getClientUserList = (id) => (dispatch) => {
  dispatch({
    payload: {
      data: [],
      count: 0,
    },
    type: CLIENT.USER_LIST.INITIATE,
  });
  return httpservice()
    .get(`${constants.API.CLINET_USER}/${id}`)
    .then((response) => {
      const count = response.data.response.length;

      const responseData = response.data.response.map((data) => (
        {
          ...data,
          name: `${data.firstName} ${data.lastName}`,
          createdAt: dateFormat(data.createdAt),
          company: data.company && data.company.name ? data.company.name : '',
          role: data.role ? data.role.roleName : '',
          createdBy: data.creator ? `${data.creator.firstName} ${data.creator.lastName}` : 'admin',
          active: (data.active) ? 'Active' : 'Pending',
          isBlocked: (data.isBlocked) ? 'Blocked' : '',
        }
      ));

      dispatch({
        payload: {
          data: responseData,
          count,
        },
        type: CLIENT.USER_LIST.SUCCESS,
      });
    })
    .catch((error) => {
      dispatch({
        payload: {
          data: [],
          count: 0,
          error,
        },
        type: CLIENT.USER_LIST.ERROR,
      });
    });
};

export const getClientWhiteIPList = (Id, object) => (dispatch) => {
  const url = constants.API.CLINET_WHITELISTED_IP.replace(ENTITY.CLIENT_ID, Id);
  let query;
  if (!object) {
    query = url;
  } else {
    switch (object.purpose) {
      case 'search':
        query = `${url}?queryOptions=like:${object.option}:=$:${object.page}`;
        break;
      case 'sort':
        query = `${url}?queryOptions=sort:${object.page}:${object.limit}`;
        break;
      case 'totalRecords':
        query = url;
        break;
      default:
        query = url;
    }
  }
  dispatch({
    payload: [],
    type: CLIENT.WHITE_IP_LIST.INITIATE,
  });
  return httpservice()
    .get(query)
    .then((response) => {
      const count = response.data && response.data.response ? response.data.response.length : 0;

      const responseData = response.data.response.map((data) => (
        { ...data, created_at: dateFormat(data.createdAt) }
      ));

      dispatch({
        payload: { data: responseData, count },
        type: CLIENT.WHITE_IP_LIST.SUCCESS,
      });
    })
    .catch((error) => {
      dispatch({
        payload: error,
        type: CLIENT.WHITE_IP_LIST.ERROR,
      });
    });
};

export const getClientSoftwareSubmodulesList = (id) => (dispatch) => {
  dispatch({
    payload: [],
    type: CLIENT.SOFTWARE_SUBMODULES.INITIATE,
  });

  return httpservice()
    .get(`${constants.API.CLIENT_SOFTWARE_SUBMODULE}/${id}`)
    .then((response) => {
      dispatch({
        payload: response.data.response,
        type: CLIENT.SOFTWARE_SUBMODULES.SUCCESS,
      });
      return response.data.response;
    })
    .catch((error) => {
      dispatch({
        payload: error,
        type: CLIENT.SOFTWARE_SUBMODULES.ERROR,
      });
    });
};

export {
  doCreateClientUser,
  getClientUserList,
};
